export type CanonicalTreeRelationshipCreationDisposition =
  | 'CREATE'
  | 'DERIVED_ONLY'
  | 'REQUIRES_TWO_ENDPOINTS';

export interface CanonicalTreeRelationshipCreationPolicy {
  readonly optionKey: string;
  readonly disposition:
    CanonicalTreeRelationshipCreationDisposition;
  readonly reason: string;
}

const DERIVED_ONLY_KEYS = new Set([
  'v_2nd_cousin',
  'v_3rd_cousin',
  'v_cousin_once_removed',
]);

const TWO_ENDPOINT_KEYS = new Set([
  'v_mother_in_law',
  'v_father_in_law',
]);

export const resolveCanonicalTreeRelationshipCreationPolicy = (
  optionKey: string,
): CanonicalTreeRelationshipCreationPolicy => {
  if (DERIVED_ONLY_KEYS.has(optionKey)) {
    return Object.freeze({
      optionKey,
      disposition: 'DERIVED_ONLY',
      reason:
        'Cousin degree and removal must be derived from actual common-ancestor parent paths.',
    });
  }

  if (TWO_ENDPOINT_KEYS.has(optionKey)) {
    return Object.freeze({
      optionKey,
      disposition: 'REQUIRES_TWO_ENDPOINTS',
      reason:
        'This in-law relationship requires both the related family anchor and the spouse-parent endpoint.',
    });
  }

  return Object.freeze({
    optionKey,
    disposition: 'CREATE',
    reason:
      'The relationship may be created through its governed structural or workflow evidence.',
  });
};

export const mayCreateCanonicalTreeRelationshipOption = (
  optionKey: string,
): boolean =>
  resolveCanonicalTreeRelationshipCreationPolicy(optionKey)
    .disposition === 'CREATE';
